/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function MessageIcon({ className, size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: sizes[size], height: sizes[size], verticalAlign: 'middle' }}
      className={className}
      viewBox="0 0 20 12"
      {...rest}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" transform="translate(-293 -1239)">
          <g transform="translate(253 1115)">
            <g transform="translate(40 120)">
              <path d="M1 15V5.551l8.56 6.247a.752.752 0 00.882-.001L19 5.552V15H1zM18.059 5L10 10.881 1.941 5h16.118zm1.191-1H.75a.75.75 0 00-.75.75v10.5c0 .413.337.75.75.75h18.5c.413 0 .75-.337.75-.75V4.75a.75.75 0 00-.75-.75z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
